import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLogoutIconSecondary from './svgs/LogoutIconSecondary.js';
import SvgLogoutIcon from './svgs/LogoutIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var logoutIcon = (props => useIcon(SvgLogoutIcon, SvgLogoutIconSecondary, props));

export { logoutIcon as default };
